import { DistributedBars } from '../../Common/Charts/DistributedBars';
import { usePacientProfileChartsDataContext } from './hooks/usePacientProfileChartsDataContext';
import { coresMescladasArray } from '../../Common/styles/colors';

export const PatientAvgPermanenceByAge = () => {
    const { chartData } = usePacientProfileChartsDataContext();

    const permanenciaPorFaixaEtaria = chartData?.avgPermanenceByAge || {};
    const subtitles = Object.keys(permanenciaPorFaixaEtaria).sort((a, b) => {
        const startOf = (label) => parseInt(label.match(/\d+/)?.[0] ?? '0', 10);
        return startOf(a) - startOf(b);
    });
    const values = subtitles.map((age) => permanenciaPorFaixaEtaria[age]);
    const colors = subtitles.map((_, index) => coresMescladasArray[index % coresMescladasArray.length]);

    return (
        <DistributedBars
            title={'Média de Permanência por Faixa Etária'}
            values={values}
            subtitles={subtitles}
            colors={colors}
        />
    );
};
